import { HeroSection } from "@/templates/sections/HeroSection"
import { getSectionVariant } from "./variants"
import { HeroSplit, HeroFullBleed, HeroMinimal, HeroVideo, HeroFloating } from "./hero_variants"
import type { BlockComponentProps } from "./shared"

/**
 * Hero never gets the generic background wrapper — each layout owns its
 * background. `centered` (default / unknown variant) is the original
 * HeroSection, unchanged for all existing sections.
 */
export function HeroBlock(props: BlockComponentProps) {
  switch (getSectionVariant(props.content)) {
    case "split":
      return <HeroSplit {...props} />
    case "full-bleed":
      return <HeroFullBleed {...props} />
    case "minimal":
      return <HeroMinimal {...props} />
    case "video":
      return <HeroVideo {...props} />
    case "floating":
      return <HeroFloating {...props} />
    default:
      return (
        <HeroSection
          content={props.content}
          customizations={props.customizations}
          org={props.org}
          inBuilder={props.inBuilder}
          styleOverrides={props.styleOverrides}
          isHomePage={props.isHomePage}
        />
      )
  }
}
